import { createAction, handleActions } from 'redux-actions';

const setActivityFetching = createAction("SCREENS/PROJECT_VIEW/SET_ACTIVITY_FETCHING");

const defaultState = false

const reducer = handleActions(
  {
    [setActivityFetching]: (state, action) => action.payload,
  },
  defaultState
);

export {
  setActivityFetching,
  reducer,
};
